export default __webpack_public_path__ + "static/media/Heartstrike Arrows.3c46a2ea.jpg";